import * as React from 'react';
import type { ReactNode } from 'react';
import type { StrictOmit } from '~/Partials/Utils/typeUtils';
import type { RadioGroupBaseProps } from './RadioGroup';

type RadioGroupContextProps = StrictOmit<RadioGroupBaseProps, 'className' | 'children'>;

interface RadioGroupProviderProps extends RadioGroupContextProps {
    children: ReactNode;
}

const radioGroupContext = React.createContext<RadioGroupContextProps>({
    name: '',
    onChange: () => {},
});

export const useRadioGroupContext = () => {
    const context = React.useContext(radioGroupContext);

    if (!context) {
        throw new Error(`Cannot render RadioGroup component`);
    }

    return context;
};

export const RadioGroupProvider = (props: RadioGroupProviderProps) => {
    const { Provider } = radioGroupContext;
    const { children } = props;

    return <Provider value={props}>{children}</Provider>;
};
